import { createContext } from 'react';

const InitialValuesContext = createContext({});

export default InitialValuesContext;
